import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propArrayShape } from '../../../helpers/custom-prop-types';
const MyPageNews = ({ list }) => (_jsxs("div", Object.assign({ className: 'notification-box' }, { children: [_jsxs("h2", { children: ['お知らせ ', _jsx(Link, Object.assign({ className: 'link-text notification-archive', to: '/news' }, { children: "\u904E\u53BB\u306E\u304A\u77E5\u3089\u305B" }))] }), _jsx("div", Object.assign({ className: 'info' }, { children: _jsx("ul", { children: list.slice(0, 20).map((news) => (_jsxs("li", { children: [_jsx("time", { children: news.createdAt }), news.action && _jsx(Link, Object.assign({ to: news.action }, { children: news.content })), !news.action && news.content] }, news.id))) }) }))] })));
MyPageNews.propTypes = {
    list: propArrayShape(),
};
MyPageNews.defaultProps = {
    list: [],
};
export default MyPageNews;
